<!-- 悬浮条 -->
<template>
  <div class="float animate__animated animate__fadeInRight animate__delay-1s">
    <!--    <div class="float-text float-text-1">-->
    <!--      <a href="https://jinshuju.net/f/DMve49" target="_blank"> 预定展位 </a>-->
    <!--    </div>-->
    <div class="float-text">
      <a href="https://jsj.top/f/s4wT6W" target="_blank"> 展位预定 </a>
    </div>
    <div class="float-text">
      <a href="https://bj3.infosalons.com.cn/reg/CADE25/app/?lang=zh-CN&type=fp06qm" target="_blank"> 预约参观 </a>
    </div>
    <div class="float-logo">
      <div class="tooltip">
        <!--        <el-tooltip class="item" placement="left">-->
        <!--          <div slot="content">-->
        <!--            <span> 同期展会即将上线 </span>-->
        <!--          </div>-->
        <a target="_blank" href="https://bauchina.com">
          <div class="flex-c">
            <img src="../../assets/img/nav-index-logo.png" alt="" />
          </div>
        </a>
        <!--        </el-tooltip>-->
      </div>
      <div class="tooltip">
        <!--        <el-tooltip class="item" placement="left">-->
        <!--          <div slot="content">-->
        <!--            <span> 同期展会即将上线 </span>-->
        <!--          </div>-->
        <a target="_blank" href="https://fenestration.com.cn">
          <div class="flex-c">
            <img src="../../assets/img/float-fbc.png" alt="" />
          </div>
        </a>
        <!--        </el-tooltip>-->
      </div>
      <!--  -->
    </div>
    <div class="float-kf">
      <el-tooltip class="item" placement="left">
        <div slot="content">
          <img style="width: 10vw" src="../../assets/img/float-kf-wechat.jpg" alt="" />
        </div>
        <img src="../../assets/img/float-kf.png" alt="" />
      </el-tooltip>
    </div>
    <!-- <div class="float-ai">
      <img src="../../assets/img/float-ai.png" alt="" />
    </div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {},

  methods: {},
};
</script>

<style scoped>
.float {
  position: fixed;
  bottom: 10%;
  right: 20px;
  width: 52px;
  padding: 10px 4px;
  /* height: 322px; */
  background-color: #fff;
  z-index: 999;
  /* background: #cab168; */
  background: #000000;
  box-shadow: 0vw 0vw 10px 0vw rgba(0, 0, 0, 0.25);
  border-radius: 43px 43px 43px 43px;
}

.tooltip:not(:last-child) {
  margin-bottom: 10px;
}

.float-text {
  text-align: center;
  font-weight: bold;
  font-size: 20px;
  color: #ffffff;
  line-height: 23px;
  padding-top: 12px;
  padding-bottom: 12px;
  margin: 0 5px;
  border-bottom: 1px solid #fff;
}

.float-text a {
  color: #ffffff;
  text-decoration: none;
}

.float-text-1 {
  /* padding-top: 19px; */
}

.float-logo {
  padding: 12px 6px;
}

.float-kf {
  cursor: pointer;
  padding: 12px 4px 0;
}

.float-ai {
  padding: 8px 4px 4px;
}

.flex-c {
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media screen and (max-width: 768px) {
  .float {
    right: 18px;
    width: 26px;
    padding: 5px 2px;
    z-index: 999;
    background: #000;
    box-shadow: 0vw 0vw 10px 0vw rgba(0, 0, 0, 0.25);
    border-radius: 43px 43px 43px 43px;
  }

  .float-text {
    font-weight: 400;
    font-size: 12px;
    color: #ffffff;
    line-height: 14px;
    padding-top: 4px;
    padding-bottom: 4px;
    border-bottom: 1px solid #fff;
  }

  .float-text a {
    color: #ffffff;
    text-decoration: none;
  }

  .float-text-1 {
    /* padding-top: 19px; */
  }

  .float-logo {
    padding: 4px 1px;
  }

  .float-kf {
    cursor: pointer;
    padding: 1px 1px 0;
  }

  .float-ai {
    padding: 1px 1px 0px;
  }

  .tooltip:not(:last-child) {
    margin-bottom: 4px;
  }

  .flex-c {
    height: 20px;
  }
}
</style>
